export const addTokenToUrl = (
  uri: string,
  token: string,
  path?: string,
): string => {
  const url = new URL(uri);

  if (path) {
    const base = url.pathname.replace(/\/+$/, "");
    const segment = path.replace(/^\/+/, "");
    url.pathname = `${base}/${segment}`;
  }

  url.searchParams.set("user_token", token);
  return url.toString();
};
